export default "__VITE_ASSET__BWXTNhSR__"